import { FC, useCallback } from "react";
import Button from "atom/button/Button";
import { PopupDialogTriggerButton } from "molecule/popupDialog/PopupDialogTriggerButton";
import { useBlocNext } from "@blac/react";
import { LyraConsentCubit } from "src/state/Lyra/LyraConsentCubit";
import { AppQueryPopupsController } from "../../AppQueryPopupsBloc";
import Translate from "components/Translate/Translate";

const TAB_ID = "9amUserAppLyraTab";

export const BehavioralPopupConnectLyraWithApi: FC = () => {
  const [{ isLoading }, { getLyraUrlWithConsent }] =
    useBlocNext(LyraConsentCubit);

  const getUrlClickHandler = useCallback(
    (consentGiven: boolean = false) =>
      () => {
        void (async () => {
          const newTab = window.open("", TAB_ID);
          try {
            const { redirectUrl } = await getLyraUrlWithConsent({
              consentGiven
            });
            if (newTab) {
              newTab.document.location.href = redirectUrl;
            }
          } catch (error) {
            newTab?.close();
            console.error(error);
          } finally {
            AppQueryPopupsController.closePopup();
          }
        })();
      },
    [getLyraUrlWithConsent]
  );

  return (
    <>
      <Button
        slot={"close"}
        onPress={getUrlClickHandler(true)}
        theme="charcoal"
        size="large"
        isDisabled={isLoading}
      >
        <Translate msg={"behavioralConnectLyra.action"} />
      </Button>
      <PopupDialogTriggerButton
        slot={"close"}
        onPress={getUrlClickHandler(false)}
        isDisabled={isLoading}
      >
        <Translate msg={"behavioralConnectLyra.noAction"} />
      </PopupDialogTriggerButton>
    </>
  );
};
